import useReveal from "../hooks/useReveal";
import { journal } from "../data/mock";
import { Link } from "react-router-dom";

export default function Journal() {
  useReveal();
  return (
    <div className="pt-32">
      <section className="mx-auto max-w-[1400px] px-6 md:px-10 py-16">
        <div className="kicker reveal">Journal</div>
        <h1 className="font-display text-4xl md:text-7xl leading-[1.02] mt-6 reveal">
          Stories, sketchbooks and <span className="italic">behind-the-scenes</span>.
        </h1>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 pb-24">
        <div className="grid md:grid-cols-3 gap-10">
          {journal.map((j) => (
            <article key={j.id} className="reveal group">
              <div className="img-zoom">
                <img src={j.image} alt={j.title} className="w-full h-[420px] object-cover" />
              </div>
              <div className="kicker mt-6 text-[hsl(var(--accent))]">{j.date}</div>
              <h3 className="font-display text-2xl md:text-3xl mt-3 leading-tight">{j.title}</h3>
              <p className="mt-3 text-[hsl(var(--ink-soft))] leading-relaxed">{j.excerpt}</p>
              <Link to="/journal" className="link-underline inline-block mt-6 text-[11px] tracking-[0.3em] uppercase">Read more</Link>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
